import React from 'react';
import { Handle, Position } from 'reactflow';

export default function StopLossNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  const mode = data.mode || 'percent';
  const isStructural = mode === 'swing' || mode === 'prev_candle';

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #f85149',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#f85149' }}>
        🛑 Stop Loss
      </div>

      <div style={{ display: 'flex', gap: 6 }}>
        <select
          value={mode}
          onChange={(e) => onChange('mode', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="percent">Percent</option>
          <option value="atr">ATR Multiple</option>
          <option value="pip">Pips (FX)</option>
          <option value="swing">Swing (structure)</option>
          <option value="prev_candle">Previous Candle</option>
          <option value="range">Range multiple (session)</option>
        </select>
        {!isStructural && (
          <input
            type="number"
            min={0.1}
            step={mode === 'pip' ? 1 : 0.1}
            value={data.value ?? 2}
            onChange={(e) => onChange('value', parseFloat(e.target.value) || 0.1)}
            style={{ width: 70, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
          />
        )}
      </div>

      {mode === 'pip' && (
        <div style={{ marginTop: 4, fontSize: 10, color: 'var(--muted)' }}>
          Distance in pips. FX only (0.0001, or 0.01 for JPY pairs).
        </div>
      )}

      {mode === 'range' && (
        <div style={{ marginTop: 6, fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
          Stop distance = multiplier × the wired Session Range's height (e.g. 2 = 200% of range).
          Wire a <strong>Session Range</strong> node into the left input.
        </div>
      )}

      {isStructural && (
        <div style={{ marginTop: 6 }}>
          <label style={{ fontSize: 11, color: 'var(--muted)' }}>
            Buffer pips (beyond the {mode === 'swing' ? 'swing' : 'candle'}):{' '}
          </label>
          <input
            type="number"
            min={0}
            value={data.buffer_pips ?? 0}
            onChange={(e) => onChange('buffer_pips', Math.max(0, parseFloat(e.target.value) || 0))}
            style={{ width: 60, padding: 2, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
          />
          <div style={{ marginTop: 4, fontSize: 10, color: 'var(--muted)' }}>
            Stop placed just beyond the last {mode === 'swing' ? 'fractal swing low (long) / high (short)' : "candle's low (long) / high (short)"}.
          </div>
        </div>
      )}

      {mode === 'atr' && (
        <div style={{ marginTop: 6 }}>
          <label style={{ fontSize: 11, color: 'var(--muted)' }}>ATR period: </label>
          <input
            type="number"
            min={2}
            value={data.atr_period ?? 14}
            onChange={(e) => onChange('atr_period', Math.max(2, parseInt(e.target.value, 10) || 14))}
            style={{ width: 60, padding: 2, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
          />
        </div>
      )}

      <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8, fontSize: 11, color: 'var(--muted)' }}>
        <input
          type="checkbox"
          checked={!!data.trailing}
          onChange={(e) => onChange('trailing', e.target.checked)}
        />
        Trailing (ratchets in your favor, never loosens)
      </label>

      <div style={{ marginTop: 6, fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
        Wire into a buy/short action's stop-loss input. Also required for "Risk %" sizing on that action.
      </div>

      {/* Range-mode stops take a Session Range node as input (its frozen height). */}
      {mode === 'range' && (
        <Handle type="target" position={Position.Left} id="range" style={{ background: '#f59e0b' }} />
      )}
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#f85149' }} />
    </div>
  );
}
